export enum QuantitiesTypes {
  Depth = 'depth',
  Length = 'length',
  Density = 'density',
  Pressure = 'pressure',
  PressureСhange = 'pressurechange',
  PressureGradient = 'pressureGradient',
  Temperature = 'temperature',
  TemperatureGradient = 'tempgrad',
  Angle = 'angles',
  AngleGradient = 'angleGradient',
  Acceleration = 'acceleration',
  SensorMagnetometer = 'sensorMagnetometer',
  Diameter = 'diameters',
  Location = 'location',
  AngularVelocity = 'angularVelocity',
}

export const defaultUnits = new Map<QuantitiesTypes, string>([
  [QuantitiesTypes.Depth, 'm'],
  [QuantitiesTypes.Length, 'm'],
  [QuantitiesTypes.Density, 'sg'],
  [QuantitiesTypes.Pressure, 'bar'],
  [QuantitiesTypes.PressureСhange, 'bar'],
  [QuantitiesTypes.PressureGradient, 'sg'],
  [QuantitiesTypes.Temperature, 'C'],
  [QuantitiesTypes.TemperatureGradient, 'C/100m'],
  [QuantitiesTypes.Angle, 'deg'],
  [QuantitiesTypes.AngleGradient, 'deg/30m'],
  [QuantitiesTypes.Acceleration, 'm/s2'],
  [QuantitiesTypes.SensorMagnetometer, 'nT'],
  [QuantitiesTypes.Diameter, 'in'],
  [QuantitiesTypes.Location, 'usft'],
  [QuantitiesTypes.AngularVelocity, 'deg/h'],
]);

export const defaultEDMUnits = new Map<QuantitiesTypes, string>([
  [QuantitiesTypes.Depth, 'ft'],
  [QuantitiesTypes.Length, 'ft'],
  [QuantitiesTypes.Density, 'ppg'],
  [QuantitiesTypes.Pressure, 'psi'],
  [QuantitiesTypes.PressureСhange, 'psi'],
  [QuantitiesTypes.PressureGradient, 'psi/ft'],
  [QuantitiesTypes.Temperature, '°F'],
  [QuantitiesTypes.TemperatureGradient, '°/100ft'],
  [QuantitiesTypes.Angle, 'deg'],
  [QuantitiesTypes.AngleGradient, 'deg/100ft'],
  [QuantitiesTypes.Acceleration, 'ft/s²'],
  [QuantitiesTypes.SensorMagnetometer, 'Gs'],
  [QuantitiesTypes.Diameter, 'in'],
  [QuantitiesTypes.Location, 'usft'],
]);
